export default {
    patchNote: "Примечания к патчу",
    currentPatchNote: "Описание текущей версии",
    newPatchNote: "Описание новой версии",
}